import {
  Component,
  OnInit,
  ViewChild,
  ElementRef,
  NgZone,
} from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { isNumeric } from "rxjs/util/isNumeric";
import { environment } from "../../../environments/environment";
import { CommonHttpService } from "../commonHttp.service";
import { LoaderService } from "../../_shared/services/loader.service";
import { AddToCartService } from "../../_shared/services/add-to-cart.service";
import "rxjs/add/operator/map";
import "rxjs/add/operator/first";
import { } from "jquery";
declare var $;
declare var $Jease$;
declare var $JssorArrowNavigator$;
declare var $JssorBulletNavigator$;
declare var $JssorSlider$;

@Component({
  selector: "app-product",
  templateUrl: "./product.component.html",
  styleUrls: ["./product.component.css"],
})
export class ProductComponent implements OnInit {
  @ViewChild(".single-top-left") selectRef: ElementRef;
  paramsId: number;
  baseUrl: any = environment.apiUrl;
  imageUrl: any = environment.imageUrl;
  productData: any = {};
  rproducts1: any = [];
  slugpara: any;
  cart: any = {};
  cartItems: any = [];
  products1: any = [];
  quantity: number = 1;
  quantityError: boolean = false;
  availableQuantity: number;
  addCartButton: boolean = true;
  relatedProducts: any = [];

  constructor(
    private service: CommonHttpService,
    private addToCartService: AddToCartService,
    private router: Router,
    private route: ActivatedRoute,
    private loaderService: LoaderService,
    private ngZone: NgZone
  ) {
    this.addToCartService.isCartChanged.subscribe((flag) => {
      this.cart = JSON.parse(localStorage.getItem("cart"));
      this.cartItems = this.cart != null ? this.cart.EcartItem : [];
      this.updateCart();
    });
  }

  ngOnInit() {
    setTimeout(() => {
      $("#owl-productimg").owlCarousel({
        //  navigation: true, // Show next and prev buttons
        slideSpeed: 300,
        autoPlay: 3000,
        dots: true,
        paginationSpeed: 400,
        singleItem: true,
      });

    }, 2000);

    window.scrollTo(0, 0);
    this.route.params.subscribe((params) => {
      //  this.paramsId = params['id'];
      this.paramsId = params["id"];
    });
    setTimeout(() => {
      this.loadData();
    }, 1);
  }

  loadData() {
    this.loaderService.display(true);
    this.service
      .get(this.baseUrl + "OfferAPI/GetBestOffersProductList")
      .subscribe(
        (data) => {
          console.log(data);
          this.products1 = data;
          window.scrollTo(0, 0);

        },
        (error) => {
          this.loaderService.display(false);
        }
      );

    var val = this.paramsId;
    if (isNumeric(val)) {
      console.log("number");
      this.service
        .get(this.baseUrl + "ProductAPI/GetSlugByProductId/" + this.paramsId)
        .subscribe(
          (data) => {
            console.log(data);
            this.slugpara = data;
            console.log(this.slugpara);
            window.location.href = "product/" + this.slugpara;
          },
          (error) => { }
        );
    } else {
      this.service
        .get(
          this.baseUrl + "ProductAPI/GetProductDetailsBySlug/" + this.paramsId
        )
        .subscribe(
          (data) => {
            this.productData = data;
            console.log(this.productData);
            this.rproducts1 = this.productData.totalStock;
            this.relatedProducts = this.productData.relatedProduct;
            console.log(this.relatedProducts);
            if (this.productData.totalStock == 0) {
              this.addCartButton = true;
            } else {
              this.addCartButton = false;
            }
            this.updateCart();
            this.ngZone.onMicrotaskEmpty.first().subscribe(() => {
              this.slide();
            });
            this.loaderService.display(false);
          },
          (error) => {
            this.loaderService.display(false);
          }
        );
    }
  }

  addToCart(product) {
    product.cartQuantity = 1;
    this.addToCartService.addToCart(product);
  }

  changeQuantity(product) {
    if (this.quantity > this.productData.totalStock) {
      this.quantityError = true;
      this.availableQuantity = this.productData.totalStock;
      this.quantity = this.productData.totalStock;
    } else {
      this.quantityError = false;
    }
    product.cartQuantity = this.quantity;
    this.addToCartService.addToCart(product);
  }

  updateCart() {
    this.productData.isAddedToCart = false;
    for (var i = 0; i < this.cartItems.length; i++) {
      if (this.cartItems[i].ProductId == this.productData.productId) {
        this.productData.isAddedToCart = true;
        this.quantity = this.cartItems[i].Quantity;
      }
    }
  }

  slide() {
    $(document).ready(function ($) {
      var options = {
        $AutoPlay: 1,
        $AutoPlaySteps: 1,
        $Idle: 2000,
        $PauseOnHover: 1,

        $ArrowKeyNavigation: 1,
        $SlideEasing: $Jease$.$OutQuint,
        $SlideDuration: 800,
        $MinDragOffsetToSlide: 20,
        //$SlideWidth: 600,
        //$SlideHeight: 300,
        $SlideSpacing: 0,
        $UISearchMode: 1,
        $PlayOrientation: 1,
        $DragOrientation: 1,

        $ArrowNavigatorOptions: {
          $Class: $JssorArrowNavigator$,
          $ChanceToShow: 2,
          $Steps: 1,
        },

        $BulletNavigatorOptions: {
          $Class: $JssorBulletNavigator$,
          $ChanceToShow: 2,
          $Steps: 1,
          $SpacingX: 12,
          $Orientation: 1,
        },
      };

      var jssor_slider1 = new $JssorSlider$("slider2_container", options);

      //responsive code begin
      //you can remove responsive code if you don't want the slider scales while window resizing
      function ScaleSlider() {
        var parentWidth = jssor_slider1.$Elmt.parentNode.clientWidth;
        if (parentWidth) {
          jssor_slider1.$ScaleWidth(parentWidth - 30);
        } else window.setTimeout(ScaleSlider, 30);
      }
      ScaleSlider();

      $(window).bind("load", ScaleSlider);
      $(window).bind("resize", ScaleSlider);
      $(window).bind("orientationchange", ScaleSlider);
      //responsive code end
    });
  }
}



// WEBPACK FOOTER //
// C:/Ajatus WorkSpace/Now Grocery/now-grocery/NowGroceryStoreFront/src/app/components/product/product.component.ts